import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import SendIcon from '@material-ui/icons/Send';
import Alert from '@material-ui/lab/Alert';
import { default as React, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { reSubmitTask } from '../../../api/task';
import { submitFile } from '../../../api/upload';
import { ApiContext } from '../../../contexts/ApiContext';
import {
  incorrectFileTypeMessage,
  mustFillMessage,
} from '../../../utils/constant';
import { arrToString, getDate } from '../../../utils/transformer';
import { isImageFromUrl } from '../../../utils/validator';
import { useSnackBar } from '../../Common/SnackBarContext';
import { ReactHookFormUpload } from '../Form';

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.typography.h1,
  },
  ketentuan: {
    margin: theme.spacing(3, 0),
  },
  img: {
    width: '20%',
    margin: 'auto',
  },
}));

const PhotoTask = ({ taskResponse }) => {
  const [response, setResponse] = useState(taskResponse);
  // console.log(taskResponse);
  const classes = useStyles();
  const { handleSubmit, errors, register, trigger } = useForm({
    mode: 'onBlur',
  });
  const apiContext = useContext(ApiContext);
  const snackBarHelper = useSnackBar();

  const [isEdit, setIsEdit] = useState(!response?.response);
  const [isSendable, setIsSendable] = useState(true);

  const task = response?.task;

  let rules = {
    required: { value: true, message: mustFillMessage },
  };

  if (task?.widget_parameters.type) {
    rules = {
      ...rules,
      validateType: {
        value: null,
        message: incorrectFileTypeMessage,
      },
    };
  }

  const onSubmit = async (data) => {
    const file = data[task?.name][0];
    snackBarHelper.openSnackBar('info', 'Mengirim...');
    setIsSendable(false);
    try {
      if (file === undefined) {
        snackBarHelper.openSnackBar('error', 'Upload file dulu');
        return;
      }
      if (file?.name) {
        const format = `${file.name.split('.').pop()}`;
        const extensions = task?.widget_parameters.type;
        if (!extensions[0].includes(format)) {
          throw new Error(
            `File hanya boleh mengandung format ${arrToString(extensions)}.`
          );
        }
        const res = await submitFile(apiContext.axios, file);
        const submissionRes = await reSubmitTask(
          apiContext.axios,
          response?.id,
          task?.id,
          res
        );
        if (submissionRes?.status === 'rejected') {
          snackBarHelper.openSnackBar('error', 'Ditolak');
        } else {
          snackBarHelper.openSnackBar('success', 'Data terkirim');
          setResponse(submissionRes.data);
          setIsEdit(true);
        }
      }
    } catch (err) {
      snackBarHelper.openSnackBar('error', err.toString());
    }
    setIsSendable(true);
  };

  const getButton = () => {
    if (isEdit && response?.status !== 'ACCEPTED') {
      return (
        <Button
          variant="contained"
          type="button"
          color="secondary"
          onClick={(e) => {
            e.preventDefault();
            setIsEdit((a) => !a);
          }}
        >
          {response?.status === 'CANCELLED' ? 'UNGGAH ULANG' : 'EDIT'}
        </Button>
      );
    }
    if (!isEdit && response?.status !== 'ACCEPTED') {
      return (
        <>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={!isSendable}
            startIcon={<SendIcon />}
          >
            Kirim
          </Button>
          <Button
            variant="outlined"
            type="button"
            color="primary"
            disabled={!isSendable}
            onClick={(e) => {
              e.preventDefault();
              setIsEdit(true);
            }}
          >
            Batal
          </Button>
          <Collapse in={!isSendable}>
            <Alert elevation={6} variant="filled" severity="info">
              Harap tetap di laman ini selama formulir Anda dikirim
            </Alert>
          </Collapse>
        </>
      );
    }
    return <h3>Terima Kasih</h3>;
  };

  useEffect(() => {
    if (taskResponse?.response) {
      setIsEdit(true);
    }
    setResponse(taskResponse);
  }, [taskResponse]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1 className={classes.title}>{task?.name}</h1>
        <div id="upload" className="mt-3">
          {!isEdit ? (
            <ReactHookFormUpload
              attr={task?.name}
              label={task?.name}
              register={register}
              error={errors[task?.name]}
              acceptedType={arrToString(task?.widget_parameters.type, '.')}
              triggerValidation={trigger}
              rules={rules}
              req={true}
            />
          ) : (
            <div>
              {isImageFromUrl(response?.response) ? (
                <>
                  <h4>Submisi Anda</h4>
                  <img
                    src={response?.response}
                    alt=""
                    className={classes.img}
                  />
                </>
              ) : (
                <>
                  Submisi Anda bisi dilihat di
                  <a href={response?.response}>sini</a>
                </>
              )}
            </div>
          )}
        </div>
        <div className={classes.ketentuan}>
          {!isEdit ? (
            <div className={''}>{task?.description}</div>
          ) : (
            <div>
              Status submisi Anda adalah{' '}
              <strong>{String(response?.status).toLowerCase()}</strong>
              <div>
                Submisi dilakukan pada {getDate(response?.last_submitted_at)}{' '}
              </div>
            </div>
          )}
        </div>
        <div id="simpan" className="mt-4">
          {getButton()}
        </div>
      </form>
    </>
  );
};

export default PhotoTask;
